import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Typography,
  Avatar,
} from "@material-tailwind/react";

function StarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-4 w-4 text-yellow-700"
    >
      <path
        fillRule="evenodd"
        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
        clipRule="evenodd"
      />
    </svg>
  );
}

const TestimonialCard = ({ testimonialsCardData }) => {
  return (
    <Card
      color="white"
      shadow={false}
      className="w-full max-w-[20rem] min-h-48 max-h-48 px-4 border"
    >
      <CardHeader
        color="transparent"
        floated={false}
        shadow={false}
        className="mx-0 flex items-center gap-4 pt-0 pb-2"
      >
        <Avatar
                                    size="lg"
                    variant="circular"
                    src={testimonialsCardData.dp}
                    alt={testimonialsCardData.name}
                />
        <div className="flex w-full flex-col gap-0.5">
          <div className="flex items-start flex-col ">
            <Typography color="blue-gray">
              {testimonialsCardData.name}
              {/* <span className="text-xs  uppercase">
                {testimonialsCardData.country}
              </span> */}
            </Typography>
            {/* <Typography className="text-sm" color="blue-gray">
              {testimonialsCardData.title}
            </Typography> */}
            <div className="5 flex items-center gap-0">
              {Array.from({ length: testimonialsCardData.rating }).map(
                (_, index) => (
                  <StarIcon key={index} />
                )
              )}
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className="mb-6 p-0">
        <p className="text-xs line-clamp-5 description_AlegreyaSans-Light">
          &quot;{testimonialsCardData.description}&quot;
        </p>
      </CardBody>
    </Card>
  );
};

export default TestimonialCard;
